import { createFileRoute } from '@tanstack/react-router'
import ContractMismatchReportOperationGroupList from '../components/contract-mismatch-report-groups/ContractMismatchReportOperationGroupList'

export const Route = createFileRoute('/_a/contractMismatchReportGroups')({
  component: ContractMismatchReportOperationGroupList,
})
